import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9cce83fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chart-container" }

import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'

import * as echarts from 'echarts'
import { ResizeService } from '@/services/resize.service'
import { getAssignPieOption } from '@/utils/echarts-option/pie'
import { getChartPiePrimaryPalette } from '@/utils/chart-theme-colors'
import { useEchartsThemeSync } from '@/composables/use-echarts-theme-sync'
import Card from '@/views/dashboard/_components/card/card.vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import PieCenter from '@/views/dashboard/_components/echarts/pie-center.vue'

interface ChartDataItem {
  name: string
  value: number
  color?: string
  /** 与统计接口 cpu_brand_distribution.device_ids 一致，用于列表按终端 id 查询 */
  device_ids?: string[]
}

export type CpuBrandSliceClickPayload = { name: string; device_ids: string[] }


export default /*#__PURE__*/_defineComponent({
  __name: 'cpu-brand-distribution-chart',
  props: {
    data: { default: () => [] }
  },
  emits: ["sliceClick"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()
const emit = __emit

const props = __props

const injector = useReflectiveInjector([ResizeService])
const resizeService = injector.get(ResizeService)

const chartRef = ref<HTMLElement>()
let chartInstance: echarts.EChartsType | null = null

const defaultColors = computed(() => getChartPiePrimaryPalette())

const chartData = computed(() => {
  if (!props.data?.length) return []
  return props.data.map((item, index) => ({
    ...item,
    color: item.color || defaultColors.value[index % defaultColors.value.length]
  }))
})

const totalCount = computed(() =>
  chartData.value.reduce((sum, item) => sum + item.value, 0)
)

const hasData = computed(() => totalCount.value > 0)

function getChartData() {
  return chartData.value.map(item => ({
    value: item.value,
    name: item.name,
    itemStyle: {
      color: item.color,
    },
  }))
}

function createChart() {
  if (!chartRef.value) return
  chartInstance = echarts.init(chartRef.value)
}

function getChartOption() {
  const option = {
    series: [{
      name: t('terminalHardware.cpuBrandDistribution'),
      data: getChartData(),
    }],
  }
  return getAssignPieOption(option, { unit: t('terminalHardware.unitTai') })
}

function renderChart() {
  if (!chartInstance) return
  chartInstance.setOption(getChartOption())
}

function bindSliceClick() {
  if (!chartInstance) return
  chartInstance.off('click')
  chartInstance.on('click', (params: { name?: string; dataIndex?: number }) => {
    const name = params?.name
    if (name == null || name === '') return
    const idx = typeof params.dataIndex === 'number' ? params.dataIndex : chartData.value.findIndex(d => d.name === name)
    const row = idx >= 0 ? chartData.value[idx] : undefined
    emit('sliceClick', { name, device_ids: row?.device_ids ? [...row.device_ids] : [] })
  })
}

function initChart() {
  chartInstance && chartInstance.dispose()
  createChart()
  renderChart()
  bindSliceClick()
}

const resizeSubscribe = resizeService.resizeSubject.subscribe(() => {
  chartInstance && chartInstance.resize()
})

watch(() => props.data, () => {
  if (!hasData.value) return
  if (!chartInstance) {
    nextTick(initChart)
  } else {
    renderChart()
  }
}, { deep: true })

useEchartsThemeSync(() => {
  if (chartInstance && hasData.value) renderChart()
})

onMounted(() => {
  if (hasData.value) {
    setTimeout(() => initChart(), 100)
  }
})

onUnmounted(() => {
  resizeSubscribe.unsubscribe()
  chartInstance?.dispose()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, {
    size: "second",
    title: _ctx.$t('terminalHardware.cpuBrandDistribution'),
    class: "cpu-brand-distribution-chart-wrap chart-card"
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "chart"
        }, null, 512),
        _createVNode(PieCenter, {
          title: _ctx.$t('terminalHardware.totalCount'),
          value: totalCount.value,
          unit: _ctx.$t('terminalHardware.unitTai')
        }, null, 8, ["title", "value", "unit"])
      ], 512), [
        [_vShow, hasData.value]
      ]),
      _withDirectives(_createVNode(EmptyData, {
        height: "100%",
        "bg-color": "transparent"
      }, null, 512), [
        [_vShow, !hasData.value]
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})